import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Close as CloseIcon } from '@mui/icons-material';
import Text from '../components/Text.js';
import { colors } from '../theme/index.js';
class Notifier extends Component {
  state = {
    hide: false
  };

  /*
   * When using the notifier in an app with redux, use the following: 
   * _close = () => {
   *     this.props.dispatch(hideNotification());
   * };
   */

  render() {
    const {
      notifierType,
      verbiage,
      showing,
      id,
      testid
    } = this.props;

    // For storybook
    const {
      close
    } = this.props;
    const styles = {
      errorNotifier: {
        backgroundColor: colors.red
      },
      messageNotifier: {
        backgroundColor: colors.brandGreen
      },
      notifier: {
        color: colors.surface,
        height: 'auto',
        left: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        minHeight: '20px',
        padding: '20px',
        position: 'absolute',
        right: '0',
        top: '2%',
        width: '600px',
        zIndex: '9999',
        maxWidth: '90%'
      },
      closeModalIcon: {
        cursor: 'pointer',
        display: 'inline',
        marginTop: -15,
        marginRight: -15,
        fontSize: 22,
        float: 'right',
        color: colors.surface
      }
    };
    if (!showing) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      id: id || testid,
      style: notifierType === 'error' ? {
        ...styles.notifier,
        ...styles.errorNotifier
      } : {
        ...styles.notifier,
        ...styles.messageNotifier
      }
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      style: styles.closeModalIcon
      // onClick={this._close}
      ,
      onClick: close
    }), /*#__PURE__*/React.createElement(Text, {
      align: "center",
      color: colors.surface,
      medium: true,
      display: "block"
    }, verbiage));
  }
}

/**
 *
 * @param {*} theme
 */

Notifier.propTypes = {
  dispatch: PropTypes.func,
  verbiage: PropTypes.string,
  notifierType: PropTypes.string,
  showing: PropTypes.bool
};
export default Notifier;